import { auth } from "@/config/firebase";
import useUser from "@/context/user";
import { i18n } from "@/utils/i18n";
import { log } from "@/utils/logger";
import { sendPasswordResetEmail } from "firebase/auth";

const useResetPassword = () => {
    const setState = useUser(state => state.setState);

    const onReset = async ({ email }: { email: string }) => {
        try {
            await sendPasswordResetEmail(auth, email);
            setState({ email });
            log.success(i18n.t("passwordResetLink", { scope: "messages.success", to: email }));
        } catch (e) {
            log.error(e);
        }
    };

    return onReset;
};

export { useResetPassword };
